module.exports = __webpack_public_path__ + "static/media/EARTHWORMS_LOW_BR.4848a4ab.mp4";